import { useMutation } from '@apollo/client';
import { LOG_NSP_INVOICE_DOWNLOAD, LOG_VENDOR_INVOICE_DOWNLOAD } from '@graphql/invoices.gql';

interface DownloadAuditParams {
  ippId: number;
  monthYear: string;
  vendorName: string;
}

export function useInvoiceDownloadAudit() {
  const [logNspDownload] = useMutation(LOG_NSP_INVOICE_DOWNLOAD);
  const [logVendorDownload] = useMutation(LOG_VENDOR_INVOICE_DOWNLOAD);

  const logNsp = ({ ippId, monthYear, vendorName }: DownloadAuditParams) => {
    logNspDownload({ variables: { ippId, monthYear, vendorName } }).catch(() => {});
  };

  const logVendor = ({ ippId, monthYear, vendorName }: DownloadAuditParams) => {
    logVendorDownload({ variables: { ippId, monthYear, vendorName } }).catch(() => {});
  };

  return { logNsp, logVendor };
}
